<template>
    <div>
        <div class="public-profile-wrapper">
            <div class="surface-section min-h-screen ">
                <div>
                    <div class="banner-responsive" :style="bannerStyleObject"></div>

                    <div class="overlap-section col-12  flex justify-content-center align-items-center">
                        <div
                            class="flex flex-column md:flex-row align-items-center justify-content-between w-full mt-3 gap-3">
                            <div class="flex flex-column md:flex-row align-items-center gap-3 text-center md:text-left">
                                <img :src="profileImage" class="profile-image" alt="Profile" />
                                <div class="profile-info">
                                    <h1 class="H5-SemiBold mb-1">{{ profileDetails?.username || "N/A" }}</h1>
                                    <p class="caption mb-0">Since {{ profileDetails?.startedYear || "N/A" }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Divider class="w-full py-2" />
                <div class="flex flex-column md:px-4 lg:flex-row gap-4 mt-4 justify-content-center">
                    <div class="w-full p-4">
                        <div class="flex flex-column justify-content-start align-self-start">
                            <div class="flex flex-wrap md:gap-6 py-2">
                                <label class="Paragraph-Medium text-left ">Address - </label>
                                <label class="Label text-left">{{ profileDetails?.address || "N/A" }}</label>
                            </div>

                            <div class="flex flex-wrap md:gap-8 py-2">
                                <label class="Paragraph-Medium text-left">BRC - </label>
                                <label class="Label text-left pl-1">{{ profileDetails?.BRC || "N/A" }}</label>
                            </div>

                            <div class="flex flex-wrap md:gap-6 py-2 items-start">
                                <label class="Paragraph-Medium text-left">About us - </label>
                                <label class="Label text-left flex-1 break-words">
                                    {{ profileDetails?.bio || "N/A" }}
                                </label>
                            </div>
                        </div>

                        <div class="py-4">
                            <h3 class="Paragraph-Medium mb-5">Our Tutors</h3>
                            <div v-if="enrolledTutors" class="grid flex flex-wrap ">
                                <div v-for="(tutor, index) in enrolledTutors" :key="index"
                                    class="col-12 sm:col-4 lg:col-3 mb-3">
                                    <div class="surface-section">
                                        <div class="flex align-items-center gap-3 mb-2">
                                            <img :src="tutor?.profilePhotoURL ? generateSignedUrl(tutor.profilePhotoURL) : blankProfile"
                                                class="w-full h-full" :alt="tutor.name" />
                                        </div>
                                        <div class="">
                                            <div>
                                                <div class="flex flex-wrap justify-content-between align-items-center">
                                                    <div class="Raleway font-semibold mb-2">{{ tutor?.username || "N/A"
                                                    }}
                                                    </div>
                                                    <Button icon="pi pi-comments" label=""
                                                        class="p-button-text Caption mb-2 black-btn " />
                                                </div>

                                                <div class=" Raleway-Medium mb-2">Professional teacher -
                                                    {{ getLastWord(tutor?.address) || 'N/A' }}
                                                </div>
                                            </div>
                                            <div class="flex flex-column gap-1 text-sm">
                                                <div class="flex align-items-center gap-2">
                                                    <span class="Raleway-Medium mb-2">{{
                                                        tutor?.teachingLanguage.join(",") }} medium</span>
                                                </div>
                                                <div class="flex flex-wrap align-items-center w-full gap-2 mt-1">
                                                    <Button label="View Profile" class="accent-button mb-2 w-full"
                                                        @click="viewTutorProfile(tutor._id)" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="flex align-items-center justify-content-center"
                                style="min-height: calc(100vh - 600px)">
                                <div class="text-center">
                                    <i class="pi pi-inbox" style="font-size: 2rem; color: var(--surface-400)"></i>
                                    <p class="mt-2 text-color-secondary">No Data found</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, defineProps } from "vue";
import bannerImg from "@/assets/Images/InstituteCoverProfile.png";
import Divider from "primevue/divider";
import Button from 'primevue/button';
import blankProfile from '@/assets/blank-profile.png';
import { generateSignedUrl } from '@/api/storage';
import { useRouter } from "vue-router";
import * as api from '@/api/admin';

const router = useRouter();
const bannerImgRef = ref(bannerImg);
const profileImage = ref(null);
const enrolledTutors = ref(null);
const profileDetails = ref(null);

const props = defineProps({
    profileDetails: null,
    // enrolledTutors: null
})

const bannerStyleObject = computed(() => ({
    backgroundImage: `url(${bannerImgRef.value})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: "100%",
}));
const getLastWord = (address) => {
    if (!address) return "";
    const words = address.trim().split(/\s+/);
    return words[words.length - 1];
};
const viewTutorProfile = (tutorId) => {
    router.push(`/admin_dashboard/tutorProfile/${tutorId}`);
}
const viewProfile = async (id) => {
    try {
        const [profile, tutors] = await Promise.allSettled([
            api.getInstituteProfile(id),
            api.getInstituteEnrolledTutors(id),
        ]);
        profileDetails.value = profile.value.data.data ?? {};
        enrolledTutors.value = tutors.value.data.data.tutors ?? [];

    } catch (err) {
        console.error("Unexpected error:", err);
    }
};
onMounted(async () => {
    const id = props.profileDetails?._id;

    if (props.profileDetails?.profilePhotoURL) {
        try {
            profileImage.value = await generateSignedUrl(props.profileDetails.profilePhotoURL);
        } catch (err) {
            console.error("Failed to generate signed URL:", err);
            profileImage.value = blankProfile;
        }
    } else {
        profileImage.value = blankProfile;
    }

    if (id) {
        viewProfile(id)
    }
});
</script>

<style scoped>
.banner-responsive {
    height: 500px;
    background-color: transparent;
}

.overlap-section {
    position: relative;
    margin-top: -4rem;
    background: transparent;
    padding: 0 1rem;
    margin-left: auto;
    margin-right: auto;
}

.profile-image {
    width: 160px;
    height: 160px;
    border-radius: 50%;
    border: 4px solid white;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
    object-fit: cover;
    margin-top: -10px;
}

.profile-info {
    display: flex;
    flex-direction: column;
    margin-top: 40px;
}

.black-btn {
    color: var(--gray-600) !important;
}

.black-btn:hover {
    color: var(--gray-600) !important;
    background-color: var(--black-50) !important;
}

@media (max-width: 767px) {
    .overlap-section {
        margin-top: -3rem;
        padding: 0 0.5rem;
    }

    .profile-image {
        width: 120px;
        height: 120px;
        margin-top: -5px;
    }

    .profile-info {
        margin-top: 15px;
    }

    .orange-button-small {
        margin-top: 15px;
    }

    .banner-responsive {
        height: 350px;
        object-fit: contain !important;
    }

}

/* Tablet Styles */
@media (min-width: 768px) and (max-width: 1023px) {
    .overlap-section {
        margin-top: -3.5rem;
    }

    .profile-image {
        width: 140px;
        height: 140px;
    }
}
</style>